module.exports = __webpack_public_path__ + "static/media/myphoto1.4bbcf645.jpg";